//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";
import { BUILD_STORAGE_IMAGE_PATH } from "@/constants/ui.js";

export default {
  name: "MainInteresting",
  components: { IconView },
  props: {
    categoryId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      mainInterestingArtSum: null,
      mainInterestingRandomObj: null,
      mainInterestingObj: null,
      innerWidth: 1000
    }
  },
  computed: {
    interestingCategoryId() {
      return this.categoryId || null
    },
    mainInterestingArtSumStore() {
      return this.$store.getters['async_fetch_data/getMainArtInterestingSum'](this.interestingCategoryId)
    },
    mainInterestingRandomObjStore() {
      return this.$store.getters['async_fetch_data/getMainRandomObjInteresting'](this.interestingCategoryId)
    },
    mainInterestingObjStore() {
      return this.$store.getters['async_fetch_data/getMainObjInteresting'](this.interestingCategoryId)
    },
    showInterestingSection() {
      return !!(this.mainInterestingArtSum || this.mainInterestingRandomObj || this.mainInterestingObj)
    },
    isInterestingArticle() {
      const item = this.mainInterestingArtSum
      return item && item._interestingItemType !== 'object'
    },
    mainInterestingArtSumLink() {
      if (!this.mainInterestingArtSum) {
        return { name: 'index' }
      }
      if (this.isInterestingArticle) {
        return { name: 'art-slug', params: { slug: this.mainInterestingArtSum.slug } }
      }
      return { name: 'objects-slug', params: { slug: this.mainInterestingArtSum.slug } }
    },
    mainInterestingArtSumHasImage() {
      return Boolean(this.mainInterestingArtSumImageUrl)
    },
    mainInterestingArtSumImageUrl() {
      if (!this.mainInterestingArtSum?.has_image) return ""

      if (!this.isInterestingArticle) {
        return `/public/object_images_files/first_image/${this.mainInterestingArtSum.id}/?preview=1`
      }

      if (this.mainInterestingArtSum.blocks?.[0]?.image?.image_file) {
        return BUILD_STORAGE_IMAGE_PATH(this.mainInterestingArtSum.blocks[0].image.image_file)
      }
      return null
    },
    mainInterestingArtSumFallbackIcon() {
      if (!this.mainInterestingArtSum || this.mainInterestingArtSumHasImage) return null
      if (!this.isInterestingArticle) {
        return this.getObjectIcon(this.mainInterestingArtSum)
      }
      return this.getArticleIcon(this.mainInterestingArtSum)
    },
    mainInterestingRandomObjIcon() {
      return this.getObjectIcon(this.mainInterestingRandomObj)
    },
    mainInterestingObjIcon() {
      return this.getObjectIcon(this.mainInterestingObj)
    },
    showedText() {
      return this.mainInterestingObj && this.mainInterestingObj.label?.length <= 50 && this.innerWidth >= 480 && this.mainInterestingObj.text?.length;
    }
  },
  watch: {
    mainInterestingArtSumStore(newVal) {
      this.mainInterestingArtSum = newVal
    },
    mainInterestingRandomObjStore(newVal) {
      this.mainInterestingRandomObj = newVal
    },
    mainInterestingObjStore(newVal) {
      this.mainInterestingObj = newVal
    },
    categoryId() {
      this.loadInteresting()
    },
  },
  mounted() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      this.innerWidth = window.innerWidth;

      window.addEventListener('resize', this.updateInnerWidth);
    }
  },
  beforeDestroy() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      window.removeEventListener('resize', this.updateInnerWidth);
    }
  },
  created(){
    this.syncFromStore()
    if (this.categoryId && !this.showInterestingSection) {
      this.loadInteresting()
    }
  },
  methods: {
    syncFromStore() {
      this.mainInterestingArtSum = this.mainInterestingArtSumStore
      this.mainInterestingRandomObj = this.mainInterestingRandomObjStore
      this.mainInterestingObj = this.mainInterestingObjStore
    },
    loadInteresting() {
      const params = this.categoryId ? { category: this.categoryId } : {}
      return this.$store.dispatch('async_fetch_data/fetchDataInteresting', params)
        .then(() => {
          this.syncFromStore()
        })
    },
    goToUser(userId) {
      this.$router.push({ name: 'u-id', params: { id: userId } });
    },
    getObjectIcon(item) {
      return item?.event_icon || item?.icon || item?.type?.icon || null
    },
    getArticleIcon(item) {
      const iconBlock = item?.blocks?.find(block => block?.data?.icon || block?.icon)
      return iconBlock?.data?.icon || iconBlock?.icon || item?.icon || null
    },
    updateInnerWidth() {
      this.innerWidth = window.innerWidth;
    }
  },
}
